<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("permissions.title", 2) }}</label>
        <v-select
          data-cy="permissions"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="permissionsFilter"
          :options="permissionsOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:permissionsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("tenants.title", 1) }}</label>
        <v-select
          data-cy="tenants"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tenantFilter"
          :options="tenantOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:tenantFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.alarm_type") }}
        </label>
        <v-select
          data-cy="alarm_type"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="alarmTypeFilter"
          :options="alarmTypeOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:alarmTypeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("users.title", 1) }}</label>
        <v-select
          data-cy="users"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="userFilter"
          :options="userOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:userFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    permissionsOptions: {
      type: Array,
      default: null,
    },
    permissionsFilter: {
      type: Array,
      default: null,
    },
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    alarmTypeOptions: {
      type: Array,
      default: null,
    },
    alarmTypeFilter: {
      type: Array,
      default: null,
    },
    userOptions: {
      type: Array,
      default: null,
    },
    userFilter: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
